














































































































import { ItemCode } from '@/game/infos/itemInfos';
import { Global } from '@/store/globalz';
import userx from '@/store/modules/userx';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CurrencyBar from '../gacha/CurrencyBar.vue';
import BlackPearlShop from '../gacha/poq/shop/BlackPearlShop.vue';
import MainQuestPanel from '../sf1/MainQuestPanel.vue';
import WeeklyQuestPanel from '../sf1/WeeklyQuestPanel.vue';

@Component({
  components: {
    MainQuestPanel,
    WeeklyQuestPanel,
    CurrencyBar,
    BlackPearlShop,
  },
})
export default class BlackPearlHome extends Vue {
  public baseUrl = process.env.BASE_URL;
  public get numBlackPearls() {
    return userx.inventory.availables[ItemCode.Gem];
  }

  public backToGame() {
    const url = Global.gameUrl || 'https://stabfish.io';
    if (url === 'iframe') {
      window.parent.postMessage({ s: '__sf', a: 'close' }, '*');
    } else {
      window.open(url + '#', 'stabfish');
    }
  }
}
